
import * as React from "react";
import {cx} from "emotion";

import "./hue-selector.scss";

import {cs} from "@Common/react/chain-services";

import {ColorPicker} from "./color-picker/color-picker";

export const HueSelector = ({color, next}) => cs(
    ["colorPicker", (_, next) => ColorPicker({
        state: color,
        next,
    })],
    ({colorPicker}) => next({
        opened: colorPicker.opened,
        render: ({className}) => (
            <div className={cx("hue-selector-13z", className)}>
                <div className="top">
                    <div className="label">
                        Hue
                    </div>
                    
                    <div className="right">
                        {colorPicker.renderToggle({})}
                    </div>
                </div>

                {colorPicker.renderPalette()}
            </div>
        ),
    }),
);
